import { render, staticRenderFns } from "./TempoSales.vue?vue&type=template&id=8b7bf8f4&scoped=true&"
import script from "./TempoSales.vue?vue&type=script&lang=js&"
export * from "./TempoSales.vue?vue&type=script&lang=js&"
import style0 from "./TempoSales.vue?vue&type=style&index=0&id=8b7bf8f4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bf8f4",
  null
  
)

export default component.exports